import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { isLoggedInSelector } from 'redux/store/slices/authSlice'
import { validateAppType } from 'utils/validate-apptype'
import * as yup from 'yup'

import { useGetTokenOTPMutation } from '../redux/api/authApi'
import { useAppSelector } from './index'

const userIDSchema = yup.object().shape({
  userID: yup.string().required()
})

export const useSuperAppAuth = () => {
  // Tools
  const [, setSearchParams] = useSearchParams()

  // Selectors
  const isLoggedIn = useAppSelector(isLoggedInSelector)

  // State
  const [isValid, setIsValid] = useState(isLoggedIn)

  // Mutations
  const [getTokenOTP] = useGetTokenOTPMutation()

  useEffect(() => {
    if (isValid) return
    const qs = new URLSearchParams(window.location.search)
    const appType = qs.get('appType')
    const userID = qs.get('userID')
    // console.warn(appType, 'appType')
    // console.warn(userID, 'userID')
    // console.warn(localStorage.getItem('access_token'), 'access_token')
    // console.warn(localStorage.getItem('refresh_token'), 'refresh_token')

    const checkAppTypeAndAuth = async () => {
      try {
        const type = await validateAppType(appType)
        if (!type) throw new Error('Some required params are missing')
        const res = await userIDSchema.validate({ userID })
        setIsValid(true)
        await getTokenOTP(res.userID).unwrap()
        setSearchParams(prev => {
          prev.delete('userID')
          return prev
        })
      } catch {
        return
      }
    }

    checkAppTypeAndAuth()
  }, [getTokenOTP, isValid, setSearchParams])
}
